import { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import Animate from 'src/components/animate';
import { DefaultLayout } from 'src/components/layouts';
import NavigatorHeader from 'src/modules/navigator/components/navigatorHeader';
import { PageContext } from 'src/constants/types';
import {
  getBannerImage,
  getBrandLogo,
  getTitle,
  getPage,
  getMenu,
  getFooter,
} from 'src/utils/navigator/navigatorUtil';

type Props = {
  navigatorId: string;
  selectedPage: string;
  personalisation: string;
}
export default function NavigatorPage({ navigatorId, selectedPage, personalisation }: Props) {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', throttle(onScroll, 300));
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const onScroll = () => {
    if (!showFloatingCTA && window.pageYOffset > 800 || window.scrollY > 800) {
      setShowFloatingCTA(true);
    }
  };

  const Footer = getFooter(navigatorId, selectedPage);

  return (
    <DefaultLayout fullWidth={true}>
      <NavigatorHeader
        bannerImage={getBannerImage(navigatorId)}
        brandLogo={getBrandLogo(navigatorId)}
        title={getTitle(navigatorId)}
      />
      {selectedPage === 'sign-up' ? (
        <div className="navigator__sign-up__container">
          <div className="navigator__split-container">
            {getPage(navigatorId, selectedPage, personalisation)}
          </div>
          <div className="navigator__split-container">
            {getMenu(navigatorId, selectedPage, personalisation)}
          </div>
        </div>
      ) : (
        <div className="navigator__container">
          <div className="navigator__content-container">
            {getPage(navigatorId, selectedPage, personalisation)}
          </div>
          <div className="navigator__sidebar-container hidden-xs">
            {getMenu(navigatorId, selectedPage, personalisation)}
          </div>
        </div>
      )}
      <Animate show={showFloatingCTA} transitionType="TRANSITION-slideUp">
        {Footer && <Footer />}
      </Animate>
    </DefaultLayout>
  );
}

NavigatorPage.getInitialProps = ({ query }: PageContext) => {
  const { week, pathname } = query;
  const navigatorId = pathname.split('/')[2];
  return { navigatorId, selectedPage: week, personalisation: query };
};

